import {AppService} from "../typescript/app/app.service";
import {PageResponse} from "../typescript/util/page-response";
import {CategoryGroup} from "./category-group";

class CategoryGroupService {

    static API_URL = "/api/categorygroups/v2";

    static findAll = (page?: number, size?: number, sort?: string, filter?: string): Promise<PageResponse<CategoryGroup>> => {
        return AppService.getAuthorized(this.API_URL, {
            page: page,
            size: size,
            sort: sort,
            id: sort?.startsWith('id') ? filter : '',
            description: sort?.startsWith('description') ? filter : ''
        }).then((result) => {
            return result.data;
        }).catch(() => {
            return {
                content: [],
                totalElements: 0
            };
        })
    };

    static findOne(id: number) {
        return AppService.getAuthorized(this.API_URL + "/" + id).then((result) => {
            return result.data;
        }).catch(() => {
            return null;
        })
    }

    static save(item: CategoryGroup) {
        if (item.id) {
            return AppService.postAuthorized(this.API_URL + "/" + item.id, item);
        } else {
            return AppService.postAuthorized(this.API_URL, item);
        }
    }

    static delete(id: number) {
        return AppService.deleteAuthorized(this.API_URL + "/" + id);
    }

    static createCategoryGroup() {
        const categoryGroup: CategoryGroup = {
            description: '',
            slug: ''
        }
        return categoryGroup;
    }
}

export {CategoryGroupService};